<!--
Author: TangChen
Date: 2018-12-08
Desc: 基金赎回，由index.js 配置引入
-->
<template>
    <div :class="'bizcomp-sell-fund bizcomp ' + className">
        <comp-title :title="title">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/home' }">
                    我的资产
                </el-breadcrumb-item>
                <el-breadcrumb-item>{{ title }}</el-breadcrumb-item>
            </el-breadcrumb>
        </comp-title>
        <el-form
            v-show="!buySuccess"
            ref="fundInfo"
            :model="fundInfo"
            :rules="rules"
            label-width="260px"
            class="pwdForm"
            inline-message
            v-on:submit.native.prevent
        >
            <el-form-item label="基金名称：" class="form-text">
                <div class="text-con">
                    {{ fund.fundname+'('+ (fund.fundcode === "515981" ? "515980" : fund.fundcode) +')' }}
                </div>
            </el-form-item>
            <el-form-item label="可用份额：" class="form-text red">
                <div class="text-con">
                    {{ $util.fmtNum(fund.availablevol)+'份' }}<span class="freeze">(冻结份额：{{ $util.fmtNum(fund.frozenvol) }}份)</span>
                </div>
            </el-form-item>
            <el-form-item v-if="sellLimit.redeemway" label="赎回至：" prop="sellTo" class="payway-list">
                <el-radio-group v-model="fundInfo.sellTo">
                    <el-radio v-if="sellLimit.redeemway.indexOf('1')>-1" label="1" name="sell">
                        现金宝
                    </el-radio>
                    <el-radio v-if="sellLimit.redeemway.indexOf('2')>-1" label="2" name="sell">
                        银行卡
                    </el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="赎回渠道：" prop="id" class="payway-list">
                <el-radio-group v-model="fundInfo.id" class="bank-radio">
                    <el-radio
                        v-for="bank in fund.fundArr"
                        :key="bank.transid+bank.index"
                        :label="bank.transid+bank.index"
                        :disabled="bank.paycenterid===$util.getConfig().const.ZX_CENTER"
                        border
                        v-on:mouseenter.native="bank.paycenterid === $util.getConfig().const.ZX_CENTER ? hover = true :''"
                        v-on:mouseleave.native="bank.paycenterid === $util.getConfig().const.ZX_CENTER ? hover = false:''"
                    >
                        <div class="bank-img-sel">
                            <img :src="$util.getImg(bank.paycenterid!==$util.getConfig().const.ZX_CENTER?bank.bankid:'xh')">
                            <div v-if="bank.paycenterid === $util.getConfig().const.ZX_CENTER && hover" class="k-text-flow">
                                <span class="zx-balance">直销柜台渠道份额需到直销柜台赎回</span>
                            </div>
                            <div v-else class="k-text-flow">
                                <span class="bank-name" :title="$cache.getDict('110080',bank.channelid)">{{ $cache.getDict('110080',bank.channelid) }}</span>总额(份)：<span
                                    class="bank-balance"
                                >{{ $util.fmtNum(bank.availablevol) }}</span>
                            </div>
                            <i class="el-icon-check" />
                        </div>
                    </el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item v-show="fundInfo.sellTo==='2'" label="赎回方式：" prop="sell" class="payway-list">
                <el-radio-group v-model="fundInfo.sell">
                    <el-radio v-if="sellLimit.redeemtype&&sellLimit.redeemtype.indexOf('0')>-1" label="0" name="sell">
                        普通赎回
                    </el-radio>
                    <el-radio v-if="sellLimit.redeemtype&&sellLimit.redeemtype.indexOf('1')>-1" label="1" name="sell">
                        快速赎回<span>(预计2小时到账，不享受当天收益)</span>
                    </el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item v-show="fund.sharetype === 'A,B'" label="收费方式：" prop="way" class="form-text">
                <el-radio-group v-model="fundInfo.sharetype">
                    <el-radio label="A" name="share">
                        前收费
                    </el-radio>
                    <el-radio label="B" name="share">
                        后收费
                    </el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item
                label="赎回份额："
                prop="amount"
                class="redemp-amount"
                :class="{'form-text':!isPwdCheck&&fundInfo.sellTo==='1'}"
            >
                <el-input
                    v-model.trim="fundInfo.amount"
                    class="prefix"
                    :placeholder="pla"
                    :maxlength="14"
                />
                <span v-if="!isAmountAll" class="redemp-btn" v-on:click.prevent="allSell"><span
                    class="like-a"
                >全部赎回</span></span>
                <!-- <p class="redemp-prompt">
                    <i class="el-icon-warning" />15点前赎回，将按{{
                        $util.fmtDate(fund.navdate)+'净值计算金额，并于'+$util.fmtDate(sellLimit.cfmdate)+'到账' }}
                    <span v-if="fund.fundtype !== '2'">{{ '，卖出费率：'+sellLimit.feerate }}</span>
                </p> -->
            </el-form-item>
            <!-- <el-form-item v-show="feeGate.charge" label="预估手续费：" class="form-text">
                <div class="text-con" v-html="feeH" />
            </el-form-item> -->
            <el-form-item v-if="isPwdCheck" label="交易密码：" prop="pwd" :class="{'form-text':fundInfo.sellTo==='1'}">
                <el-input
                    v-model.trim="fundInfo.pwd"
                    type="password"
                    placeholder="请输入交易密码"
                    :maxlength="20"
                />
                <span class="redemp-btn" v-on:click.prevent="$router.push({name: 'tradepwd'})"><span class="like-a">忘记密码？</span></span>
            </el-form-item>
            <!-- 赎回界面不需要阅读基金合同等文件 -->
            <!-- <el-form-item style="margin-left:-80px">
                <div v-if="readFileInfoList.length!==0" class="check-box bar-pad showChenckbox" style="font-size: 14px; display: flex; align-items: flex-start;">
                    <div style="display: flex; align-items: center;">
                        <input v-model="checkbox" type="checkbox" />
                        <span style="padding-left:5px;color:red;">我已阅读并同意: </span>
                    </div>
                    <ul>
                        <li v-for="(item,index) in readFileInfoList" :key="index">
                            <a
                                v-if="$cache.getCompanyInfo().pdf_open_way === '0'"
                                target="_blank"
                                v-on:click="getClick(index)"
                            >《{{ item.textname }}》</a>
                            <a v-else :href="item.textaddress" style="text-decoration:none; color: red" target="_blank">《{{ item.textname }}》</a>
                        </li>
                    </ul>
                </div>
            </el-form-item> -->
            <el-form-item>
                <div style="width:50%;">
                    <el-button type="primary" class="medium" v-on:click="submitInfo('fundInfo')">
                        确认赎回
                    </el-button>
                    <el-button class="medium" v-on:click="$router.back()">
                        返回
                    </el-button>
                </div>
            </el-form-item>
            <trade-apply-rule title="交易须知：" :rules="sellRules"></trade-apply-rule>
        </el-form>
        <result
            v-if="buySuccess"
            :result="result"
            v-on:return-page="$router.push({name:'traderecord'})"
            v-on:return-login="$router.push({name:'home'})"
        />
        <fund-protocol v-model="protocol" :fund="xjbFundRisk" v-on:all-read="sellFund" />
        <pdf-popup base64 :visible="pdfVisible" :need-time="needTime" :read-file-info-list="currentFileInfoList" v-on:close="finishReading"></pdf-popup>
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import result from "@/components/layout/result.vue";
import fundProtocol from "@/components/form/fundProtocol";
import PdfPopup from "@/components/util/pdfPopup";
import tradeApplyRule from "@/components/form/tradeApplyRule.vue";

export default {
    name: "Sell",
    components: {
        result,
        fundProtocol,
        PdfPopup,
        tradeApplyRule
    },
    mixins: [mixin],
    data() {
        return {
            feeH: "", // 费率信息
            fundInfo: {
                amount: "",
                id: "",
                sell: "",
                sharetype: "",
                sellTo: "",
                pwd: ""
                // protocol: ""
            },
            protocol: false,
            isPwdCheck: false,
            isAmountAll: false,
            pla: "请先选择赎回渠道",
            fund: {}, // 基金信息获取
            sellLimit: {},
            buySuccess: false, // 购买状态
            result: {// 结果页面信息
                cla: "register-success",
                msg: "您的基金赎回申请已提交成功！",
                btnMsg: "预计确认时间：2018-11-16，如遇节假日则顺延，请耐心等待",
                special: false,
                btnL: {
                    text: "查看交易记录",
                    event: "return-page"
                },
                btnR: {
                    text: "返回我的资产",
                    event: "return-login"
                }
            },
            bankLists: [],
            xjbFundRisk: {}, // 现金宝适当性信息检查
            query: null,
            rules: {
                amount: [
                    {validator: this.amountLimit, trigger: "change"}
                ],
                id: [
                    {required: true, message: "请选择赎回渠道", trigger: "change"}
                ],
                pwd: [
                    {required: true, message: "请输入交易密码", trigger: "change"}
                ]
            },
            limit: {min: "0.01", max: "0", text: "赎回份额范围为："},
            bankInfo: {},
            feeGate: {},
            hover: false,
            checkbox: false, //阅读确认
            pdfVisible: false,
            needTime: false,
            readFileInfoList: [],//披露文件信息
            currentFileInfoList: [],//当前阅读信批文件
            sellRules: [
                { content: "个别银行的到账时间可能存在延迟，具体以银行的到账时间为准。" },
                { content: "为保护长期投资者利益，根据证监会规定，对持有期较短的赎回行为，由基金公司收取≥0.5%的费用。" },
                { content: "15点后的交易申请将作为下一交易日的申请，实际提交时间以受理时间为准。" }
            ]
        };
    },
    watch: {
        "fundInfo.id"(val) {
            this.bankInfo = this.fund.fundArr.filter(item => {
                return item.transid + item.index === val;
            })[0];
            const _max = this.fundInfo.sell === "0" ? (Number(this.bankInfo.availablevol) > Number(this.sellLimit.normalmax) ? this.sellLimit.normalmax : this.bankInfo.availablevol) : (Number(this.bankInfo.availablevol) > Number(this.sellLimit.fastmax) ? this.sellLimit.fastmax : this.bankInfo.availablevol);
            this.$set(this.limit, "max", _max);
            this.pla = Number(this.limit.min) < Number(_max) ? ("本次可赎回" + this.$util.fmtNum(this.limit.min) + "-" + this.$util.fmtNum(_max) + "份") : "本次只可全部赎回剩余份额";
            if (this.fundInfo.amount) {
                this.$refs.fundInfo.validateField("amount");
                this.queryRate();
            }
        },
        "fundInfo.sell"(val) {
            if (this.fundInfo.sell === "1") {
                this.isPwdCheck = this.$cache.getPwdCheck("98");
            } else {
                this.isPwdCheck = this.$cache.getPwdCheck("24");
            }
            if (this.fundInfo.sellTo === "1") return;
            const _max = val === "0" ? (Number(this.bankInfo.availablevol) > Number(this.sellLimit.normalmax) ? this.sellLimit.normalmax : this.bankInfo.availablevol) : (Number(this.bankInfo.availablevol) > Number(this.sellLimit.fastmax) ? this.sellLimit.fastmax : this.bankInfo.availablevol);
            const _min = val === "0" ? this.sellLimit.normalmin : this.sellLimit.fastmin;
            this.$set(this.limit, "min", _min);
            this.$set(this.limit, "max", _max);
            this.pla = Number(_min) < Number(_max) ? ("本次可赎回" + this.$util.fmtNum(_min) + "-" + this.$util.fmtNum(_max) + "份") : "本次只可全部赎回剩余份额";
            if (this.fundInfo.amount) {
                this.$refs.fundInfo.validateField("amount");
            }
        },
        "fundInfo.sharetype"(val) {
            if (val === "B") {
                this.feeGate = {};
            }
        },
        "fundInfo.sellTo"(val) {
            let _max = "";
            let _min = "";
            if (val === "1") {
                _max = Number(this.bankInfo.availablevol) > Number(this.sellLimit.xjbmax) ? this.sellLimit.xjbmax : this.bankInfo.availablevol;
                _min = this.sellLimit.xjbmin;
            } else {
                _max = this.fundInfo.sell === "0" ? (Number(this.bankInfo.availablevol) > Number(this.sellLimit.normalmax) ? this.sellLimit.normalmax : this.bankInfo.availablevol) : (Number(this.bankInfo.availablevol) > Number(this.sellLimit.fastmax) ? this.sellLimit.fastmax : this.bankInfo.availablevol);
                _min = this.fundInfo.sell === "0" ? this.sellLimit.normalmin : this.sellLimit.fastmin;
            }
            this.$set(this.limit, "min", _min);
            this.$set(this.limit, "max", _max);
            this.pla = Number(_min) < Number(_max) ? ("本次可赎回" + this.$util.fmtNum(_min) + "-" + this.$util.fmtNum(_max) + "份") : "本次只可全部赎回剩余份额";
            if (this.fundInfo.amount) {
                this.$refs.fundInfo.validateField("amount");
                this.queryRate();
            }
        },
        "fundInfo.amount"(val) {
            this.isAmount(val);
        },
        readFileInfoList: {
            handler: function(obj){
                if (obj.every(function (item) {
                    return item.read;//产品概要强制阅读，其他不用
                })) {
                    this.checkbox = true;
                    //this.checkTime = false;
                }
            },
            deep: true
        },
        checkbox(val) {
            if(this.readFileInfoList.length !== 0){
                if (val && !this.isReadFileReading && !this.readFileInfoList[0].read) {
                    this.currentFileInfoList = [this.readFileInfoList[0]];
                    this.needTime = true;
                    this.pdfVisible = true;
                }
                if (!val) {
                    this.readFileInfoList.forEach(item => item.read = false);
                }
            }
        }
    },
    mounted() {
        this.fund = JSON.parse(sessionStorage.getItem(this.$route.name));
        if(this.fund.fundArr.length > 0){
            let fundArr = Object.assign([],this.fund.fundArr);
            let zx = [];
            this.fund.fundArr = this.fund.fundArr.filter(fund => fund.paycenterid !== this.$util.getConfig().const.ZX_CENTER);
            zx = fundArr.filter(fund => fund.paycenterid === this.$util.getConfig().const.ZX_CENTER);
            zx.forEach(item => this.fund.fundArr.push(item));
        }
        this.isPwdCheck = this.$cache.getPwdCheck(this.fund.way);
        this.getSellInfo();
        this.getFileInfo();
    },
    methods: {
        /* 提交表单数据，校验用户信息 */
        submitInfo(formName) {
            // 赎回界面不需要阅读基金合同等文件
            // if (this.readFileInfoList.length !== 0) {
            //     if (!this.checkbox) {
            //         return this.$alert("根据相关法规要求，请在交易前仔细阅读相关文件，并勾选“我已阅读并同意”选项。", "提示", {confirmButtonText: "确定"});
            //     }
            // }
            const _this = this;
            _this.$refs[formName].validate(valid => {
                if (valid) {
                    if (_this.fundInfo.sellTo === "1") {
                        _this.$util.getSdxProtocol({
                            fundcode: _this.sellLimit.xjbfundcode,
                            proto: "sell"
                        }, (res) => {
                            _this.xjbFundRisk = res;
                            _this.protocol = true;
                        });
                    } else {
                        this.sellFund(true);
                    }
                } else {
                    return false;
                }
            });
        },
        sellFund(val) {
            this.protocol = false;
            if (!val) return;
            const _this = this;
            let data = {
                branchcode: _this.bankInfo.branchcode,
                transid: _this.bankInfo.transid,
                tano: _this.bankInfo.tano,
                sharetype: _this.bankInfo.sharetype,
                fundstatus: _this.bankInfo.fundstatus,
                redeemway: _this.fundInfo.sellTo,
                amount: _this.fundInfo.amount,
                fundcode: _this.bankInfo.fundcode,
                redeemtype: _this.fundInfo.sell,
                tradepwd: this.$util.enc(_this.fundInfo.pwd)
            };
            if (_this.fundInfo.sellTo === "1") {
                data.riskwarnflag = _this.xjbFundRisk.riskwarnflag;
                data.riskmismatchflag = _this.xjbFundRisk.riskmismatchflag;
                data.highriskwarnflag = _this.xjbFundRisk.highriskwarnflag;
                data.fundmismatchflag = _this.xjbFundRisk.fundmismatchflag;
                data.targetsharetype = _this.sellLimit.xjbsharetype;
            }
            _this.$util.request("trade/redeem", data, "POST").then(res => {
                if (res.data) {
                    this.result.cla = "register-success";
                    if (this.fundInfo.sell === "0") {
                        this.result.btnMsg = "预计确认时间：" + this.$util.fmtDate(res.data[0].cfmdate || res.data[0].confirmeddate) + "， 如遇节假日则顺延，请耐心等待";
                    } else {
                        this.result.btnMsg = "预计确认时间：两小时内到账，请耐心等待";
                    }
                } else {
                    this.result.cla = "register-fail";
                    this.result.btnMsg = "原因：" + res.msg;
                }
                this.result.msg = "您的赎回申请已受理" + (this.result.cla === "register-fail" ? "失败" : "成功");
                this.buySuccess = true;
                console.log("112121")
            });
        },
        // 全部取现处理
        allSell() {
            this.fundInfo.amount = Number(this.bankInfo.availablevol) + "";
            this.$refs.fundInfo.validateField("amount");
            this.isAmountAll = true;
        },
        // 处理金额
        isAmount(val) {
            const _val = this.$util.checkAmount(val);
            clearTimeout(this.query);
            this.$set(this.fundInfo, "amount", _val);
            if (this.fundInfo.amount === this.bankInfo.availablevol) {
                this.isAmountAll = true;
            } else {
                this.isAmountAll = false;
            }
            this.query = setTimeout(() => {
                this.queryRate();
            }, 1);
        },
        // 费率入参获取
        queryRate() {
            const _this = this;
            let _d = null;
            if (this.fundInfo.amount > 0 && this.fundInfo.sharetype === "A" && this.bankInfo.channelid && this.fund.fundtype !== "2") {
                _d = {
                    fundcode: this.fund.fundcode,
                    amount: this.fundInfo.amount,
                    channelid: this.bankInfo.channelid,
                    bizcode: this.fundInfo.sellTo === "1" ? "4" : "3",
                    targetfundcode: this.fundInfo.sellTo === "1" ? _this.sellLimit.xjbfundcode : ""
                };
            }
            this.$util.getFee(_d, res => {
                _this.feeGate = res;
                _this.feeH = "<span class=\"red\">" + _this.$util.fmtNum(_this.feeGate.charge) + "元</span>(<s>" + _this.$util.fmtNum(_this.feeGate.originfee) + "</s>元，为您节省<span class=\"red\">" + _this.$util.fmtNum(_this.feeGate.discount) + "</span>元)";
            });
        },
        amountLimit(rule, value, callback) {
            if(value === this.bankInfo.availablevol){
                return callback();
            }
            this.$util.validateAmountLimit(this, rule, value, callback);
        },
        // 赎回前数据查询
        getSellInfo() {
            const _this = this;
            this.$util.request("trade/redeem/info", {
                fundcode: this.fund.fundcode,
                tano: this.fund.tano,
                specialflag: this.fund.specialflag
            }).then(res => {
                if (res.data) {
                    _this.sellLimit = res.data[0][0];
                    if (_this.sellLimit.redeemway.indexOf("1") > -1) {
                        _this.$util.fundRiskCheck(_this, {
                            fundcode: _this.sellLimit.xjbfundcode,
                            proto: "sell"
                        }, function (data) {
                            _this.xjbFundRisk = data;
                        });
                    }
                    _this.$set(_this.fundInfo, "id", _this.fund.fundArr[0].transid + _this.fund.fundArr[0].index);
                    _this.$set(_this.fundInfo, "sharetype", _this.fund.sharetype.substr(0, 1));
                    _this.$set(_this.fundInfo, "sell", _this.sellLimit.redeemtype.substr(0, 1));
                    _this.$set(_this.fundInfo, "sellTo", _this.sellLimit.redeemway.substr(0, 1));
                    //针对有效期过期可操作赎回---屏蔽转换现金宝途径
                    if (_this.$cache.getUser().certexpired === "1") {
                        _this.sellLimit.redeemway = "2";
                        _this.$set(_this.fundInfo, "sellTo", "2");
                    }
                }
            });
        },
        //获取链接点击事件
        getClick(index){
            this.currentFileInfoList = [this.readFileInfoList[index]];
            this.readFileInfoList[index].read = true;
            if (this.currentFileInfoList[0].texttype === "1") {
                this.needTime = true;
            } else {
                this.needTime = false;
            }
            this.pdfVisible = true;
        },
        finishReading () {
            this.pdfVisible = false;
            if (this.currentFileInfoList[0].texttype === "1") {
                this.isReadFileReading = true;
            }
        },
        //获取披露文件信息
        getFileInfo(){
            var _this = this;
            this.$util.queryReadFileInfo({"tano": this.fund.tano,"fundcode": this.fund.fundcode,"flag": "0"},res=>{
                res.forEach(item => {
                    item.read = false;
                    if(item.texttype.trim() === "1"){//产品概要
                        _this.readFileInfoList.unshift(item);
                    }else{
                        _this.readFileInfoList.push(item);
                    }
                });
            });
        }
    }
};
</script>
<style lang="scss">
    @import "../../assets/css/varibles";

    .bizcomp-sell-fund {
        padding-bottom: 30px;
    }
</style>
